import { PayloadAction, createSlice } from "@reduxjs/toolkit";

const initialState = { value: "" };

const infoSlice = createSlice({
  name: "info",
  initialState,
  reducers: {
    infoSet: (state, action) => {
      state.value = action.payload;
    },
    infoClear: (state) => {
      state.value = "";
    },
  },
});
export const { infoSet, infoClear } = infoSlice.actions;
export default infoSlice.reducer;
